var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallCoffeeCup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.688 5.625h-.938l-1.448-4.343A1.874 1.874 0 0021.524 0H5.469c-.807 0-1.516.516-1.771 1.282L2.25 5.625h-.938a.937.937 0 00-.937.938v1.875c0 .517.42.937.938.937h1.162l1.512 18.9A1.875 1.875 0 005.856 30h15.288c.978 0 1.791-.751 1.87-1.726l1.511-18.899h1.163c.518 0 .937-.42.937-.938V6.563a.937.937 0 00-.938-.938zM6.151 2.812h14.696l1.25 3.75H4.901l1.25-3.75zm.57 24.375l-.45-5.625h14.456l-.45 5.625H6.721zm14.682-14.062H5.596l-.3-3.75h16.407l-.3 3.75z",
    fill: "#91C300"
  })));
}

export default SvgSmallCoffeeCup;